import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class RegistryService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    create(data) {
        return Vue.axios.post(`${API_HOST}/api/Registry`, data, {
                headers: {
                    'Authorization': `Bearer ${$store.getters.accessToken}`
                },
                cancelToken: this.cancelTokenSource.token,
            })
    }
}

export default new RegistryService()